export default {"src":"/_next/static/media/MacularDegeneration.d26996e5.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};